import React from 'react';

const ManageAllOrders = () => {
  
    return (
        <div>
        {/* <p className='text-center text-2xl lg:text-3xl font-medium my-10'>Manage All Orders {orders.length}</p> */}

    </div>
);

};

export default ManageAllOrders;